<div class=" p-4 rounded-lg border-dashed border-4 border-gray-300 relative"
    style="resize: both !important; width:200px; height:200px" [style.height.px]='height' [style.width.px]='height'
    id="widget_viewbox" (mousemove)="onMouseMove($event)">

    <div style="position: absolute; bottom:0; right:0" (mouseup)="onMouseUp($event)" (mousedown)="onMouseDown($event)">
        Grab</div>


</div>